exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.v-card__title.v-card__title--primary[data-v-5316058a] {\n  padding: 14px 24px 0px 24px;\n}\n", ""]);

